import { Link } from "react-router-dom";
import { Mail, Phone, Clock, MapPin, Sparkles } from "lucide-react";

export default function Contact() {
  return (
    <>
      <section className="container-edge py-20 grid grid-cols-12 gap-10">
        <div className="col-span-12 md:col-span-7">
          <div className="eyebrow mb-3"><Sparkles size={14} className="fill-coral" /> Get in Touch</div>
          <h1 className="display-serif text-5xl sm:text-6xl leading-[0.98] mb-8">
            Let's start with <span className="hand-accent text-coral">hello</span>.
          </h1>
          <p className="text-muted2 leading-relaxed max-w-xl mb-12">
            For groups of 25 or more, the fastest way to reach us is the quote form. For everything else,
            here's how to find us:
          </p>

          <div className="space-y-6">
            {[
              { icon: Mail, label: "Email", val: "tours@knvtravelz.com", href: "mailto:tours@knvtravelz.com" },
              { icon: Phone, label: "Phone", val: "862-235-4515", href: "tel:+18622354515" },
              { icon: MapPin, label: "Office", val: "407 Lincoln Rd, Suite 6H Deck 1690", note: "Miami Beach, FL 33139" },
              { icon: Clock, label: "Office Hours", val: "Mon–Fri · 8am–6pm ET", note: "On-trip support is 24/7 for groups currently traveling." },
            ].map(({ icon: Icon, label, val, href, note }) => (
              <div key={label} className="bg-white rounded-3xl p-6 ring-1 ring-ink/8 flex items-start gap-5">
                <div className="w-12 h-12 rounded-2xl bg-terracotta/10 flex items-center justify-center shrink-0">
                  <Icon size={22} className="text-terracotta" />
                </div>
                <div>
                  <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink/55 mb-1">{label}</div>
                  {href ? (
                    <a href={href} className="display-serif text-2xl hover:text-terracotta transition-colors">{val}</a>
                  ) : (
                    <div className="display-serif text-2xl">{val}</div>
                  )}
                  {note && <div className="text-sm text-muted2 mt-1">{note}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="col-span-12 md:col-span-5">
          <div className="bg-ink text-cream rounded-[2rem] p-10 relative overflow-hidden md:sticky md:top-28">
            <div className="absolute -top-20 -right-20 w-60 h-60 bg-coral/25 rounded-full blur-3xl" />
            <div className="relative">
              <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-sun mb-5">Start Here</div>
              <h2 className="display-serif text-3xl text-cream leading-tight mb-4">
                Got a group of 25 or more?
              </h2>
              <p className="text-cream/75 text-sm leading-relaxed mb-7">
                The quote form takes about three minutes and tells us everything we need to draft a tailored
                proposal — college tour or dream destination.
              </p>
              <Link to="/request-quote" className="btn-primary w-full">Plan My Trip</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
